/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const CountryFormatter = (cellContent, row, rowIndex) => {
  const { name } = row;
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {name ? name : "-"}
      </div>
      <> </>
    </>
  );
};
